import { Button, Container, Label } from '@playcanvas/pcui';

import { Events } from '../events';
import { localize } from './localization';
import { Menu } from './menu';
import collapseSvg from './svg/collapse.svg';
import logo from './svg/simam-logo.svg';
import { Tooltips } from './tooltips';
import { version } from '../../package.json';

const createSvg = (svgString: string) => {
    const decodedStr = decodeURIComponent(svgString.substring('data:image/svg+xml,'.length));
    return new DOMParser().parseFromString(decodedStr, 'image/svg+xml').documentElement;
};

// The docked bar across the top of the editor: column toggle, brand and menu on the left,
// the workspace switcher in the centre. The right-hand cell is deliberately empty - it
// balances the grid so the centre stays centred, and nothing fake goes in it.
class TopBar extends Container {
    center: Container;

    constructor(events: Events, tooltips: Tooltips, menu: Menu, args = {}) {
        args = {
            ...args,
            id: 'top-bar'
        };

        super(args);

        const left = new Container({
            id: 'top-bar-left'
        });

        const collapse = new Button({
            id: 'top-bar-collapse'
        });
        collapse.dom.appendChild(createSvg(collapseSvg));

        const setCollapsed = (collapsed: boolean) => {
            document.body.classList[collapsed ? 'add' : 'remove']('left-collapsed');
            collapse.dom.setAttribute('aria-expanded', String(!collapsed));
        };

        collapse.on('click', () => {
            setCollapsed(!document.body.classList.contains('left-collapsed'));
        });

        // narrow screens start with the column out of the way, as the old menu collapse did
        setCollapsed(window.innerWidth < 600);

        const brand = new Container({
            id: 'top-bar-brand'
        });

        const brandMark = document.createElement('img');
        brandMark.id = 'top-bar-logo';
        brandMark.src = logo;
        brandMark.alt = '';
        brand.dom.appendChild(brandMark);

        brand.append(new Label({
            id: 'top-bar-name',
            text: 'Simam 3D Studio'
        }));

        brand.append(new Label({
            id: 'top-bar-version',
            text: `v${version}`
        }));

        left.append(collapse);
        left.append(brand);
        left.append(menu);

        this.center = new Container({
            id: 'top-bar-center'
        });

        const right = new Container({
            id: 'top-bar-right'
        });

        this.append(left);
        this.append(this.center);
        this.append(right);

        tooltips.register(collapse, localize('tooltip.top-bar.toggle-left-column'), 'bottom');
    }
}

export { TopBar };
